import { JobSiteModel } from "../../customer-portal/models/job-site.model";
import { PaymentProvider } from "../../customer-portal/models/payment-provider.enum";

export function getPastDate(month: number): Date {
  const date = new Date();
  date.setMonth(date.getMonth() - month);

  return date;
}

export function transformDataToIsoString(date: Date): string {
  const day = date.getDate().toString();
  const month = (date.getMonth() + 1).toString();
  const dayFormatted = day.length < 2 ? `0${day}` : day;
  const monthFormatted = month.length < 2 ? `0${month}` : month;

  return `${date.getFullYear()}-${monthFormatted}-${dayFormatted}`;
}

export function jobSiteFilter(jobSite: JobSiteModel, value: string): boolean {
  const filterValue = value.toLowerCase();

  return (
    jobSite.jobName.toLowerCase().includes(filterValue) ||
    jobSite.jobAddress.toLowerCase().includes(filterValue)
  );
}

const numericPattern = /[^\d.]/g;

export function formatPrice(
  value: string | number = "",
  min = 0,
  max = null,
  currency = "$",
): string {
  let price =
    parseFloat(value.toString().replace(numericPattern, "")) || max || min;

  if (price < min) {
    price = min;
  }

  if (max && price > max) {
    price = max;
  }

  return `${currency} ${price.toFixed(2)}`;
}

export function convertExpiryDate(expiry: string): string {
  if (expiry) {
    const year = expiry.substring(2, 4);
    let month = expiry.substring(4);

    if (month.length === 1) {
      month = `0${month}`;
    }

    return `${month}${year}`;
  }

  return null;
}

export function fixedEncodeURIComponent(str): string {
  return encodeURIComponent(str).replace(
    /[!'()*.]/g,
    (c) => `%${c.charCodeAt(0).toString(16)}`,
  );
}

export function getProperty(obj, path): string | number {
  return path.split(".").reduce((o, p) => o && o[p], obj);
}

export function getPaymentName(data: string): string {
  return data.substr(data.length - 4) ?? "****";
}
